/** @typedef {import('../index.js').InvalidDocData} InvalidDocData */
import Product, { productSchema, ProductStatus } from './product.js';
import ProductVersion, { productVersionSchema, reorderPolicySchema } from './productVersion.js';

export function normalizeProductSku(sku) {
  return sku.trim().toUpperCase();
}

function fromFirestore(Model, label, doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return Model.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Error transforming ${label} data:`, docData.id, error);
    /** @type {InvalidDocData} */
    const invalidDocData = { validation: 'failed', ...docData };
    return invalidDocData;
  }
}

function productFromFirestore(doc) {
  return fromFirestore(Product, 'product', doc);
}

function productVersionFromFirestore(doc) {
  return fromFirestore(ProductVersion, 'product version', doc);
}

function productToFirestore(product, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new Product(product).toFirestore({ serverTimestamp });
}

function productVersionToFirestore(productVersion, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new ProductVersion(productVersion).toFirestore({ serverTimestamp });
}

export {
  Product,
  ProductVersion,
  ProductStatus,
  productSchema,
  productVersionSchema,
  reorderPolicySchema,
  productFromFirestore,
  productToFirestore,
  productVersionFromFirestore,
  productVersionToFirestore,
};
